import React, { Fragment, PureComponent } from 'react';
import { connect } from "react-redux";

import {
    FormGroup,
    Label,

} from 'reactstrap';

 // app config
 import AppConfig from 'Constants/AppConfig';

// rct card box
import RctCollapsibleCard from 'Components/RctCollapsibleCard/RctCollapsibleCard';

import {
  
} from 'Actions';


class ViewDocument extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
           
        };
    }

    

    render() {

        const { particularcontractdocument, loading} = this.props; 
        return (
            <>
                <div className="row">
                    <div className="col-sm-12 col-lg-8">                        
                            <RctCollapsibleCard
                                heading={
                                    <div style={{ display: 'flex', alignItems: 'center', borderBottom: "1px solid #ccc" }}>
                                        <span>Student Profile</span>
                                        <button type="button" className="mr-10 mb-10 btn btn-outline-warning ml-auto" onClick={this.props.onClick}>Back</button>
                                    </div>
                                }
                            >
                             <div className="row">
                                <div className="col-lg-6">
                                    <span>Name : <strong>{particularcontractdocument[0].student}</strong></span>
                                </div>
                                <div className="col-lg-6">
                                    <span>Date Of Birth : <strong>{particularcontractdocument[0].cdate}</strong></span>
                                </div>
                                <div className="col-lg-6">
                                    <span>Phone Number : <strong>{particularcontractdocument[0].uud_phone}</strong></span>
                                </div>
                             </div>   
                            </RctCollapsibleCard>                        
                    </div>
                    <div className="col-sm-12 col-lg-12">                        
                            <RctCollapsibleCard
                                heading={
                                    <div style={{ display: 'flex', alignItems: 'center', borderBottom: "1px solid #ccc" }}>
                                        <span>Document Description</span>
                                    </div>
                                }
                            >
                             <div className="row">
                                <div className="ss">{particularcontractdocument[0].csd_desc}</div>
                             </div>  
                             <div className="row">
                                    <iframe src={AppConfig.apiurl+'/theme/img/documents/'+particularcontractdocument[0].csd_filename} width="100%" height={800}  ></iframe>
                             </div> 
                            </RctCollapsibleCard>                        
                    </div>
                </div>
            </>
        )
    }
}
const mapStateToProps = ({ contractstudent }) => {
    const { particularcontractdocument, loading } = contractstudent;
    return { particularcontractdocument, loading };

}

export default connect(mapStateToProps, {
    
})(ViewDocument);